import { schema, record } from '@sharingapples/redux';
var structure = {
  guides: schema('guides', 1),
  guideSearchQuery: record('guideSearchQuery'),
  guideSearchFilters: record('guideSearchFilters'),
  guideSortKeys: record('guideSortKeys'),
  treks: schema('treks')
};
export default structure;